/* eslint-disable react/prop-types */
import React from "react";
import Avatar from "@usb-ui-tools/react-billpay-avatar";
import { BlockLayout } from "../index";
import PropTypes from "prop-types";
import USBNotification from "@usb-shield/react-notification/dist/esm";
import { USBIconClose } from "@usb-shield/react-icons/dist/esm";
import { getIconAssistiveText } from "../utils/getIconAssistiveText";

function shouldShowNotification(notificationArray) {
  const notifArray = notificationArray.filter(
    (notification) => notification?.show
  );
  return notifArray.length > 0;
}

/*PageTitle functions */
function renderOnlyH1(id: any, pageTitleText: any) {
  return (
    <h1
      id={`${id}_page_title`}
      className="usb-tg-display-small usb-c-usb-blue-primary"
    >
      {pageTitleText}
    </h1>
  );
}
function renderButtonIconWithH1(
  id: any,
  pageTitleText: any,
  pageTitleButtonDockRight: any
) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <h1
        id={`${id}_page_title`}
        className="usb-tg-display-small usb-c-usb-blue-primary"
      >
        {pageTitleText}
      </h1>
      <div>{pageTitleButtonDockRight}</div>
    </div>
  );
}

/*CardTitle functions */
function renderAvatar(isPayeeInternal: any, AvatarSrc: any) {
  return (
    <Avatar
      {...{
        src: AvatarSrc,
        alt: "",
        variant: isPayeeInternal ? "biller" : "company",
        id: "avatar",
        compact: true,
      }}
    />
  );
}
function renderCardTitle(
  id: any,
  isOLBOrIpadApp: any,
  cardTitleText: {} | null | undefined,
  mobileZeroTopMarginHeading: boolean
) {
  return isOLBOrIpadApp() ? (
    <h2
      id={`${id}_card_title`}
      className="usb-tg-subheader-large"
      style={{ marginTop: "0.25rem" }}
    >
      {cardTitleText}
    </h2>
  ) : (
    <h1
      id={`${id}_card_title`}
      className="usb-tg-header-large usb-c-usb-blue-primary"
      style={mobileZeroTopMarginHeading ? {} : { marginTop: "0.25rem" }}
    >
      {cardTitleText}
    </h1>
  );
}
function RenderCardFirstChild({
  showAvatar,
  isPayeeInternal,
  AvatarSrc,
  cardTitleText,
  nickName,
  subLevelText,
  id,
  isOLBOrIpadApp,
  notificationArray,
  compact,
  mobileZeroBottomMarginFirstChild = false,
  contentOnTop = null,
  showContentOnTop = true,
  dockRightContent = null,
  showDockRight = false,
  cardOtherBlockProps = {},
  mobileZeroTopMarginHeading,
  subLevelTextWithFullWidth = null
}): JSX.Element {
  return (
    <BlockLayout
      actAs="CardFirstChild"
      mobileZeroBottomMarginFirstChild={mobileZeroBottomMarginFirstChild}
      contentOnTop={showContentOnTop ? contentOnTop : null}
      compact={compact}
      {...cardOtherBlockProps}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          columnGap: "1rem",
        }}
      >
        {showAvatar && renderAvatar(isPayeeInternal, AvatarSrc)}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            columnGap: "1rem",
            justifyContent: "space-between",
            width: "inherit",
          }}
        >
          {(cardTitleText || nickName || subLevelText) && (
            <div>
              {cardTitleText &&
                renderCardTitle(id, isOLBOrIpadApp, cardTitleText,mobileZeroTopMarginHeading)}
              {nickName && (
                <p
                  style={{ marginTop: "0.5rem" }}
                  className="usb-c-gray-80 usb-tg-body-small"
                >
                  {nickName}
                </p>
              )}
              {subLevelText && (
                <p
                  style={{ marginTop: "1rem" }}
                  className="usb-c-gray-70 usb-tg-subheader-large"
                >
                  {subLevelText}
                </p>
              )}
            </div>
          )}
          {showDockRight && dockRightContent}
        </div>
      </div>
      {(!isOLBOrIpadApp() && subLevelTextWithFullWidth) && <div>{subLevelTextWithFullWidth}</div>}
      {!isOLBOrIpadApp() && renderNotifications(notificationArray, id)}
    </BlockLayout>
  );
}

/*Notification functions */
function renderNotifications(notificationArray: any[], id: any) {


  return (
    Array.isArray(notificationArray) &&
    notificationArray.length > 0 &&
    notificationArray.map((notification, index) => {
      const {
        show = true,
        roleType = "alert",
        type,
        message,
        handleCloseFunction = null,
        iconAssistiveText= {label: getIconAssistiveText(type)}
      } = notification;
      if (show) {
        return (
          <div
            style={{ width: "100%" }}
            key={`${id}_page_notification_${index + 1}`}
          >
            <USBNotification
              variant={type}
              roleType={roleType}
              id={`${id}_page_notification_${index + 1}`}
              data-test={`${id}_page_notification_${index + 1}`}
              handleClose={handleCloseFunction}
              iconAssistiveText={iconAssistiveText}
              closeIconNode={
                handleCloseFunction ? (
                  <USBIconClose
                    title="close"
                    assistiveText={{ label: "close" }}
                  />
                ) : null
              }
            >
              {message}
            </USBNotification>
          </div>
        );
      }
      return <></>;
    })
  );
}

const CardTitle = ({
  notificationArray,
  isPayeeInternal,
  AvatarSrc,
  showAvatar,
  pageTitleText,
  pageNickname,
  pageSubText,
  cardTitleText,
  nickName,
  subLevelText,
  id,
  isOLBOrIpadApp,
  cardTitleTextSameAsPageTitleText,
  pageTitleButtonDockRight = null,
  compact,
  pageContentOnTop,
  contentOnTop,
  showContentOnTop,
  dockRightContent,
  showDockRight,
  cardOtherBlockProps,
  mobileZeroBottomMarginFirstChild,
  mobileZeroTopMarginHeading,
  subLevelTextWithFullWidth,
  ...otherBlockProps
}) => (
  <>
    <BlockLayout
      actAs={isOLBOrIpadApp() ? "PageHeader" : "Ghost"}
      compact={compact}
      contentOnTop={pageContentOnTop ? pageContentOnTop : null}
      {...otherBlockProps}
    >
      {!pageTitleButtonDockRight && renderOnlyH1(id, pageTitleText)}
      {pageTitleButtonDockRight &&
        renderButtonIconWithH1(id, pageTitleText, pageTitleButtonDockRight)}
      {((nickName && isOLBOrIpadApp()) ||
        (subLevelText && isOLBOrIpadApp())) && (
        <>
          {pageNickname && (
            <p
              style={{ marginTop: "0.5rem" }}
              className="usb-c-gray-80 usb-tg-body-small"
            >
              {pageNickname}
            </p>
          )}
          {pageSubText && (
            <p
              style={{ marginTop: "1rem" }}
              className="usb-c-gray-70 usb-tg-subheader-large"
            >
              {pageSubText}
            </p>
          )}
        </>
      )}
      {isOLBOrIpadApp() && renderNotifications(notificationArray, id)}
    </BlockLayout>
    {(cardTitleText ||
      (pageTitleText &&
        cardTitleTextSameAsPageTitleText &&
        !isOLBOrIpadApp()) ||
      (nickName && !isOLBOrIpadApp()) ||
      (subLevelText && !isOLBOrIpadApp()) ||
      (subLevelTextWithFullWidth && !isOLBOrIpadApp()) ||
      (shouldShowNotification(notificationArray) && !isOLBOrIpadApp())) && (
      <RenderCardFirstChild
        {...{
          showAvatar,
          isPayeeInternal,
          AvatarSrc,
          cardTitleText: cardTitleTextSameAsPageTitleText
            ? pageTitleText
            : cardTitleText,
          nickName,
          subLevelText,
          id,
          compact,
          isOLBOrIpadApp,
          mobileZeroBottomMarginFirstChild,
          notificationArray,
          contentOnTop,
          showContentOnTop,
          dockRightContent,
          showDockRight,
          cardOtherBlockProps,
          mobileZeroTopMarginHeading,
          subLevelTextWithFullWidth
        }}
      />
    )}
  </>
);

CardTitle.propTypes = {
  compact: PropTypes.bool,
  notificationArray: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf([
        "error",
        "confirmation",
        "warning",
        "information",
      ]),
      message: PropTypes.string,
    })
  ),
  showAvatar: PropTypes.bool,
  mobileZeroBottomMarginFirstChild: PropTypes.bool,
  mobileZeroTopMarginHeading: PropTypes.bool,
  subLevelTextWithFullWidth: PropTypes.node
};
CardTitle.defaultProps = {
  notificationArray: [],
  showAvatar: true,
  cardTitleTextSameAsPageTitleText: false,
  mobileZeroBottomMarginFirstChild: false,
  mobileZeroTopMarginHeading: false,
  subLevelTextWithFullWidth: null
};
export default CardTitle;
